import { TimeRangeIDs } from "@documents/models/filter.models";

export enum ReportType {
  WHO_ACCESSED_DOCUMENTS_REPORT = "WHO_ACCESSED_DOCUMENTS_REPORT",
  DOCUMENT_REPORT = "DOCUMENT_REPORT",
  WHO_ACCESSED_DATA_ROOMS_REPORT = "WHO_ACCESSED_DATA_ROOMS_REPORT",
  WHO_ACCESSED_EVENT_REPLAYS_REPORT = "WHO_ACCESSED_EVENT_REPLAYS_REPORT",
  WHO_ACCESSED_FEATURED_INSIGHTS_REPORT = "WHO_ACCESSED_FEATURED_INSIGHTS_REPORT",
  BOUNCE_BACK_REPORT = "BOUNCE_BACK_REPORT",
  TERMS_ACCEPTANCE_REPORT = "TERMS_ACCEPTANCE_REPORT",
}

export type ServiceType = "documents" | "entitlements";

export interface ReportConfig {
  service: ServiceType;
  endpoint: string | null;
}

export interface FilterAvailability {
  filterName: string;
  hasData: boolean;
  dataAvailableFrom: string | null;
  dataAvailableTo: string | null;
  recommendedTimeRange: TimeRangeIDs;
}

export interface ReportAvailabilityResponse {
  hasData: boolean;
  filters: FilterAvailability[];
}

export interface ReportAvailabilityRequest {
  reportType: string;
}
